import { Popup } from '@progress/kendo-react-popup';
import ClickOutside from 'app/widgets/ClickOutside';
import React, { useEffect } from 'react';
import './BasePopup.less';
import clsx from 'clsx';
interface Props {
  anchor?: HTMLElement;
  children: React.ReactNode;
  className?: string;
  appendToAnchor?: boolean;
  ignoreAnchorOnMobile?: boolean;
  onClose: () => void;
}

export default function BasePopup({
  anchor,
  children,
  className,
  appendToAnchor,
  ignoreAnchorOnMobile,
  onClose,
}: Props) {
  const menuOpen = Boolean(anchor);

  useEffect(() => {
    if (menuOpen) {
      window.addEventListener('scroll', onClose, true);
    }

    return () => {
      window.removeEventListener('scroll', onClose, true);
    };
  }, [menuOpen, onClose]);

  return (
    <Popup
      // Note: React doesn't render this popup correctly when we close it onScroll. The key prop says that it needs to be unmounted.
      key={menuOpen ? 'open' : 'closed'}
      anchor={anchor}
      show={menuOpen}
      anchorAlign={{ horizontal: 'left', vertical: 'bottom' }}
      popupAlign={{ horizontal: 'left', vertical: 'top' }}
      margin={{ vertical: 5, horizontal: 0 }}
      appendTo={
        appendToAnchor
          ? anchor
          : ignoreAnchorOnMobile
          ? document.body
          : undefined
      }
      className={clsx('base-popup', {
        'base-popup__mobile-fullscreen': ignoreAnchorOnMobile,
      })}
    >
      <ClickOutside
        className={className}
        onClickOutside={e => {
          if (e.target !== anchor) {
            onClose();
          }
        }}
      >
        {children}
      </ClickOutside>
    </Popup>
  );
}
